import { Country } from './country';

export interface Accommodation {
  // Present at runtime for saved accommodations (returned by GET /trips/:id).
  // Optional because newly added ones have no id until saved.
  id?: string;
  title?: string;
  countryCode: string;
  type: AccommodationType;
  peoplePerRoom: number;
  isEcoFriendly: boolean;
  nights: number;
  scheduledDays?: number[];
  countries: Country;
  accommodationImpactDetail?: {
    impact: number;
  };
  customEmissionFactor?: { name: string };
}

export enum AccommodationType {
  HomeExchangePrincipalResidenceOrBedAndBreakfast = 'homeExchangePrincipalResidenceOrBedAndBreakfast',
  HomeExchangeSecondaryResidence = 'homeExchangeSecondaryResidence',
  AllHotels = 'allHotels',
  HotelsDoubleStar = 'hotelsDoubleStar',
  HotelsTripleStar = 'hotelsTripleStar',
  HotelsQuadrupleStar = 'hotelsQuadrupleStar',
  HotelsQuintupleStar = 'hotelsQuintupleStar',
  CampingInATent = 'campingInATent',
  Bivouac = 'bivouac',
  MountainRefuge = 'mountainRefuge',
  LightHousingYurtTinyHouse = 'lightHousingYurtTinyHouse',
  SeasonalRenting = 'seasonalRenting',
  YouthHostel = 'youthHostel',
  OtherAccommodation = 'otherAccommodation',
  CustomFactor = 'custom',
}

export const HOTELS = [
  AccommodationType.AllHotels,
  AccommodationType.HotelsDoubleStar,
  AccommodationType.HotelsTripleStar,
  AccommodationType.HotelsQuadrupleStar,
  AccommodationType.HotelsQuintupleStar,
];
export const PER_ACCOMMODATION = [AccommodationType.LightHousingYurtTinyHouse];
